<template>
  <div class="menu-main">
    <!-- <ul class="menu-list">
      <li
        class="menu-item"
        :class="currentName === item.name && 'menu-item-active'"
        v-for="(item, index) in navMenuList"
        :key="index"
        @click="goTo(item)"
      >
        <div class="menu-name">{{ item.name }}</div>
        <div class="menu-active"></div>
      </li>
    </ul> -->
    <el-menu
      @select="handleSelect"
      class="menu-list"
      background-color="transparent"
      mode="horizontal"
    >
      <template v-for="item in navMenuList">
        <!-- <el-submenu
          v-if="item.submenu"
          :key="item.name"
          popper-class="sub-menu-list"
        >
          <template slot="title">{{ item.name }}</template>
          <el-menu-item v-for="sub in item.submenu" :key="sub.name">{{
            item.name
          }}</el-menu-item>
        </el-submenu> -->
        <template v-if="item.submenu">
          <OEMSubMenu :key="item.name" :menu="item" :index="item.path" />
        </template>
        <el-menu-item :key="item.name" :index="item.path" v-else>{{
          item.name
        }}</el-menu-item>
      </template>
    </el-menu>

    <!-- todo: 使用router-link渲染报错
    Cannot read properties of undefined (reading 'resolve') -->
    <!-- <router-link to="/">Go to Home</router-link> -->
  </div>
</template>

<script>
import Storage from "@/utils/Storagehandle";
export default {
  name: "OEMMenu",
  data() {
    return {
      currentName: "",
      navMenuList: [
        {
          name: "数据首页",
          path: "/developer/#/data",
        },
        {
          name: "产品管理",
          path: "/developer/#/product/list",
        },
        {
          name: "生产管理",
          path: "/developer/#/production/list",
        },
        {
          name: "增值服务",
          path: "/developer/#/service",
        },
        {
          name: "运营管理",
          path: "/developer/#/operation",

          // submenu: [
          //   {
          //     name: "用户反馈",
          //     path: "/developer/#/operation",
          //   },
          // {
          //   name: "云菜谱",
          //   path: "/operator/cooking/classList",
          //   submenu: [
          //     {
          //       name: "食谱管理",
          //       path: "/operator/cooking/menuList",
          //     },
          //     {
          //       name: "分类管理",
          //       path: "/operator/cooking/classList",
          //     },
          //   ],
          // },
          // ],
        },
        {
          name: "文档中心",
          path: "/developer/#/document",
        },
      ],
    };
  },
  created() {
    // console.log(this.$route);
    // this.currentPath = this.$route.path;
    let currentRoute = Storage.getItem("currentRoute");
    if (currentRoute) {
      this.currentName = currentRoute.name;
    } else {
      this.currentName = "产品管理";
    }
  },
  methods: {
    handleSelect(item) {
      // console.log(item, keyPath);
      history.pushState(null, item, item);
    },
    // todo: main中使用的store，是子应用的store，main中是否可以有自己的store
    // goTo(item) {
    //   console.log(this.$store);
    //   this.currentName = item.name;
    //   Storage.setItem("currentRoute", item);
    //   history.pushState(null, item.path, item.path);
    // },
  },
};
</script>

<style lang="less">
.menu-main {
  height: 52px;
}
.sub-menu-list {
  background: #fff;
}
.menu-list {
  // background: transparent;
  border-bottom: none !important;
  li {
    color: #fff;
  }
}
.menu-list .el-submenu__title {
  // width: 120px;
  // padding-left: 0 !important;
}
.el-submenu > .el-submenu__title:hover {
  color: auto !important;
}

.el-menu-item {
  display: inline-block;
  width: 120px;
  padding-top: 16px;
  // line-height: 52px !important;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  border: none !important;
}

.el-menu--horizontal > .el-menu-item {
  color: #fff !important;
}
.el-menu--horizontal > .el-menu-item.is-active {
  color: #fff !important;
}
.el-menu--horizontal > .el-submenu > .el-submenu__title {
  color: #fff !important;
  padding-left: 0;
}
.el-menu--popup {
  min-width: 134px !important;
}
.el-submenu .el-menu-item {
  min-width: 134px !important;
}

.el-menu--horizontal > .el-submenu.is-active .el-submenu__title {
  border-bottom: none !important;
}
</style>
